import React from 'react'

import History from '@/Helpers/History'
import useTranslation from '@/Hooks/UseTranslation'
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader'
import { RESOURCES_NAVIGATION, ResourcesTab } from './resources-navigation'

interface Props {
  activeTab: ResourcesTab
  children?: React.ReactNode
  projectId: string
  subtitle?: string
}

const ResourcesHeader = ({ activeTab, children, projectId, subtitle }: Props) => {

  const { t } = useTranslation()

  const tabs = RESOURCES_NAVIGATION.map((tab) => ({
    label: t(tab.translationKey),
    icon: <i className={tab.icon} />,
    onClick: () => History.push(`/project/${projectId}${tab.path}`),
    active: activeTab === tab.id,
    disabled: !projectId,
  }))

  return (
    <ContentHeader
      className="pl4-resources-header pl4-page-header"
      title={t('NAVIGATION:Resources')}
      subtitle={subtitle}
      navTabs={tabs}
    >
      {children}
    </ContentHeader>
  )
}

export default ResourcesHeader
